import { Link } from "@tanstack/react-router"
import React from "react"

// Links will be ordered in the same way they are defined in the array
export const adminTabLinks = [
  { to: "/administration/users", label: "Users" },
  { to: "/administration/apikeys", label: "API Keys" },
  { to: "/administration/auth-groups", label: "Authorization Groups" },
  { to: "/administration/certificates", label: "Certificates" },
]

const AdminTabs = () => {
  return (
    <div className="text-sm font-medium text-center text-gray-500 border-b border-gray-200 mb-3">
      <ul className="flex flex-wrap -mb-px">
        {adminTabLinks.map((link) => (
          <li key={link.to} className="me-2">
            <Link
              to={link.to}
              className="inline-block p-4 border-b-2 rounded-t-lg"
              activeProps={{
                className: "active text-blue-600 border-blue-600",
              }}
              inactiveProps={{
                className:
                  "border-transparent hover:text-gray-600 hover:border-gray-300",
              }}
            >
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default AdminTabs
